module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.0.0.box.210.768.1206.278.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.22.0.0.box.210.768.1206.278.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _vm._v("Gumbos, Soups, and Salads")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.0.0.box.588.271.525.46.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.24.0.0.box.588.271.525.46.q.90"
    }
  }, [_vm._v("CHICKEN STOCK")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.24.1.0.box.175.393.1349.578.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0012.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.2.0.box.173.1069.1355.1252.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.0.box.175.1069.1352.308.q.60"
    }
  }, [_vm._v("Wash the chicken well in cold water. Remove as much of the skin as possible and place the chicken (whole) into a large stockpot or gumbo pot. Add the water and bring to a boil over high heat. Once the pot begins to boil, reduce the heat to low and add all the remaining ingredients. Cover the pot well and let it simmer for 3½ hours.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.1.box.175.1397.1353.370.q.60"
    }
  }, [_vm._v("Remove from the heat and lift the chicken out of the pot. When the chicken is cool enough, remove most of the meat from the bones and return the bones to the stockpot. Set aside the chicken meat for use in another dish, such as chicken salad. Return the stockpot to the heat and simmer the stock for 2 more hours, tightly covered. Remove from heat and let it cool enough for you to handle it, then strain the bones and vegetables out of the liquid.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.2.box.175.1778.1353.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.2.0"
    }
  }), _vm._v("Refrigerate the stock for 6 hours, then skim the fat and foam off the top. You should get about 2 quarts of excellent stock. This may be eaten as is, or you can use it as a soup or sauce base.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.24.2.3.box.173.2007.1353.253.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("Homemade stock is hard to beat! The making"), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.4.1.0"
    }
  }), _vm._v(" of the stock is not really hard at all; it just takes time. Make it on a day that you are doing something else away from the kitchen. Then you can either refrigerate the stock for use up to 4 days later or freeze it for use at a much later date.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "2em"
    },
    attrs: {
      "id": "para.24.2.4.box.320.2278.1205.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.4.2.0"
    }
  }), _vm._v("To use, just let the stock thaw in the refrigerator and use as"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.0.0.box.270.267.1249.100.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _vm._v("\nyou would any fresh stock or broth. Only about 23 calories per cup, so you are adding great flavor with very few calories.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.25.0.0.box.270.267.1249.100.q.50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.651.478.388.43.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.25.1.0.box.651.478.388.43.q.80"
    }
  }, [_vm._v("BEEF STOCK")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.25.2.0.box.170.593.1345.477.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.25.3.0.box.171.1136.1351.953.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.3.0.box.171.1136.1348.193.q.60"
    }
  }, [_vm._v("Preheat the oven to 500 degrees. Chop the soup meat into small pieces and set aside. Place the beef ribs in a shallow baking pan and bake them until they are quite brown but not burnt, about 20 minutes. Turn the ribs after 10 minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.3.1.box.171.1346.1350.411.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.1.0"
    }
  }), _vm._v("While the ribs are browning, saute the soup meat over medium heat in a medium (about 2-gallon-size) gumbo pot until it is well browned. Do not let the meat stick. When the meat is browned, add the water and bring to a hard boil. When the liquid is boiling, add the rest of the ingredients and reduce the heat to a low simmer. Add the browned ribs to the stockpot and simmer for 4 to 6 hours. Should the level of the water fall below the soup meat and ribs, add enough water to cover and lower the heat more.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.3.2.box.172.1778.1350.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.2.0"
    }
  }), _vm._v("When the simmering time is up, remove from the heat and let the stock cool. Strain the cooled broth through a fine sieve and place the broth in the refrigerator to chill. The fat should rise to the top and harden somewhat. Remove as much of the fat as possible. This should make about 2 quarts of excellent stock. It may be eaten as is or used as a base for other soups or sauces.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.4.0.box.171.2156.1350.149.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.25.4.0.box.171.2156.1350.149.q.60"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.5.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("You can make this stock ahead of time and "), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.5.1.0"
    }
  }), _vm._v("store it in the refrigerator for up to 4 days or put it into airtight containers (canning jars are excellent if you allow room for the soup to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.0.0.box.273.271.1251.100.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _vm._v("\nexpand) and freeze it for a few months. Let the stock thaw at room temperature and use as you would any broth.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.26.0.0.box.273.271.1251.474.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.0.1.box.273.380.1251.365.q.60"
    }
  }, [_vm._v("Don't toss out the leftover meat from the broth pot. Even though the bulk of the flavor has been removed, you can chop the meat finely (it is very tender) and use it mixed with potatoes to make excellent hash. You can also season it up with barbecue sauce and make nice Sloppy Joes. Only about 31 calories per cup; a great way to liven up any dish with very few calories added.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.570.862.556.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.26.1.0.box.570.862.556.46.q.70"
    }
  }, [_vm._v("SEAFOOD GUMBO")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.26.2.0.box.168.960.1360.1165.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0014.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.3.0.box.170.2173.1353.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.3.0.box.170.2173.1353.151.q.60"
    }
  }, [_vm._v("In a heavy metal pot, heat the cup of cooking oil over medium heat. Add the flour and cook until you get a reddish-brown roux. Remember to stir constantly. When the desired color is reached, add the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.0.0.box.170.268.1350.100.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("\nonions, celery, bell pepper, and garlic and saute for 7 minutes. Then add the tomatoes, saving the juice in the can for later use.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.27.0.0.box.170.268.1353.1067.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.1.box.170.379.1351.365.q.60"
    }
  }, [_vm._v("Saute the tomatoes for 5 minutes, then add the juice from the tomatoes and the tomato sauce. Cook for 3 minutes, then add the Seafood Stock, bay leaves, sweet basil, thyme, Tabasco sauce, salt, black pepper, garlic powder, onion powder, white pepper, and Worcestershire sauce and bring to a boil. Once the dish has come to a boil, reduce to a low simmer and cook the gumbo for 1½ hours, covered.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.2.box.172.761.1350.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.2.0"
    }
  }), _vm._v("In a heavy metal pot that has a lid, combine the okra and the 3 tablespoons of cooking oil, cover, and bake in a 375-degree oven for 35 minutes, stirring 4 times during the baking process. The okra should be cooking while the gumbo is simmering. When the okra is ready, add it to the simmering gumbo and replace the cover. Add the crabs, cover pot, and cook for 15 more minutes. Add the shrimp and cook for 15 minutes at a low simmer. Add the oysters, green onions, and parsley and cook at low simmer for 10 more minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.0.3.box.172.1194.1351.141.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.3.0"
    }
  }), _vm._v("Check seasoning and adjust salt and pepper to your taste. Pour into individual serving bowls and add the file powder and cooked white rice. Serves 8 to 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.1.0.box.171.1407.1354.358.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.27.1.0.box.171.1407.1354.358.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("May be made in advance and refrigerated or"), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.1.0"
    }
  }), _vm._v(" frozen for later use without any harm to the dish. If you do not like okra, you can leave it out. You can also vary the kinds of seafood to suit your taste. Serve with plenty of hot French bread and potato salad. About 495 calories in each of 10 servings or 618 in each of 8 servings. Add 112 calories per serving for "), _c('i', [_vm._v("½ ")]), _vm._v("cup of cooked white rice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.0.0.box.552.271.588.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.28.0.0.box.552.271.588.43.q.70"
    }
  }, [_vm._v("CRAWFISH GUMBO")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.28.1.0.box.170.387.1326.749.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0015.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.28.2.0.box.171.1202.1352.843.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.0.box.171.1202.1352.362.q.60"
    }
  }, [_vm._v("In a very heavy gumbo pot or large, heavy saucepot, heat the oil over medium heat for 4 minutes, then add the flour. Cook over medium heat, stirring constantly, until the roux turns dark brown. When the desired color is reached, add the onions, celery, garlic, and bell pepper and saute the vegetables in the roux for 5 minutes. Add the stewed tomatoes and saute for 5 more minutes, then slowly add the hot water. Stir until the roux is dissolved.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.1.box.171.1582.1352.314.q.60"
    }
  }, [_vm._v("Add the salt, black pepper, cayenne pepper, Tabasco sauce, bay "), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.2.0"
    }
  }), _vm._v("leaf, sweet basil, and Worcestershire sauce and stir well. Bring the mixture to a boil, then reduce the heat to a rolling simmer and cook for 1 hour. Add the crawfish tails and reduce the heat to a low simmer. Cook for 25 minutes over low heat until the crawfish are tender. Add the green onion and parsley.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.2.box.171.1906.1352.139.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.3.0"
    }
  }), _vm._v("Check seasoning and add salt and pepper to your taste. Serve hot in individual serving bowls with file powder over cooked white rice. Serves 8 to 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.3.0.box.170.2117.1354.153.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.28.3.0.box.170.2117.1354.153.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This is an excellent dish to make in advan"), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.4.1.0"
    }
  }), _vm._v("ce and either refrigerate or freeze for later use. It actually improves the dish to make it at least 1 day in advance. To reheat, just thaw in the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.0.0.box.269.268.1250.155.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _vm._v("\nrefrigerator if frozen and heat over low heat until the gumbo is hot. Use this recipe to make an excellent Shrimp Gumbo by substituting shrimp for crawfish.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.29.0.0.box.269.268.1250.361.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.0.1.box.269.433.1250.196.q.50"
    }
  }, [_vm._v("About 325 calories per serving in 10 servings without rice. With "), _c('i', [_vm._v("½ ")]), _vm._v("cup of cooked rice there are about 437 calories per serving. In 8 servings there are about 405 calories without rice or 517 calories with rice.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.392.736.906.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.29.1.0.box.392.736.906.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("CHICKEN AND OKRA GUMBO")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.29.2.0.box.171.854.1348.957.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0016.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.3.0.box.174.1872.1352.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.3.0.box.174.1872.1352.361.q.60"
    }
  }, [_vm._v("In a gumbo pot or large stockpot (2V2 to 3 gallons), heat the cooking oil over high heat until the oil begins to smoke. Add the flour and stir constantly with a wire whisk or wooden spoon, making sure that the roux is constantly moving and not sticking in any part of the pot. (I find that tilting the pot from one side to another helps.) Continue to cook over high heat until the roux becomes a dark reddish-brown. This will take about 3 minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.3.1.box.220.2251.1302.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.4.1.0"
    }
  }), _vm._v("When the desired color is reached, add the onions, bell pepper,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.0.0.box.171.271.1351.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _vm._v("\ngarlic, and celery. Saute over medium heat in the roux for 2 minutes, stirring constantly. Season the chicken with the Chicken Seasoning Mix. Fry half of the chicken in the roux mixture over medium heat for 5 minutes, then remove that half and fry the other half for 5 minutes.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.30.0.0.box.171.271.1351.814.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.0.1.box.171.488.1351.424.q.60"
    }
  }, [_vm._v("Put all the chicken back into the pot and add the Chicken Stock. Stir until the roux is absorbed into the stock. Add the tasso, bay leaf, sweet basil, garlic powder, onion powder, white pepper, cayenne pepper, black pepper, Tabasco sauce, and salt. Heat over medium heat until the gumbo comes to a boil, then reduce the heat to low. Simmer for 1½ hours, then add the smothered okra and the teaspoon of file powder and continue to cook at a low simmer for 2½ more hours.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.0.2.box.171.932.1350.153.q.60"
    }
  }, [_vm._v("Add the green onions and parsley and stir them in well. Cook for 7 more minutes at a low simmer. Serve hot in individual serving bowls with file powder over cooked white rice. Serves 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.170.1151.1352.1013.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.30.1.0.box.170.1151.1352.467.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This is Cajun cooking at its best. Gumbo i"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  }), _vm._v("s one of the mainstays of the Cajun people. It can be made a day in advance and put in the refrigerator. This not only doesn't hurt it; it actually seems to improve the flavor. The gumbo will keep in the refrigerator up to 4 days. It also freezes well. To reheat, just thaw in the refrigerator and heat the amount you are planning to eat over low heat until it comes to the temperature you like. Add file powder to taste and serve over cooked white rice.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.269.1638.1253.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.2.0"
    }
  }), _vm._v("To make Chicken and Andouille Gumbo, just follow the recipe as above except substitute andouille sausage for the tasso. Andouille sausage is a very spicy Cajun sausage, and it really lends itself to a gumbo. (If you cannot find tasso, beef jerky is an acceptable substitute.)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.30.1.2.box.271.1910.1251.254.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.3.0"
    }
  }), _vm._v("About 782 calories per serving of the gumbo without rice and 894 calories with ½ cup of rice. While this seems like a lot of calories, it is not when you consider that gumbo over rice is a complete one-dish meal for under 900 calories. I would not suggest making any changes in the recipe to reduce the calories.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.0.0.box.632.263.438.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.31.0.0.box.632.263.438.45.q.70"
    }
  }, [_vm._v("DUCK GUMBO")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.31.1.0.box.176.381.1301.796.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0017.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.31.2.0.box.172.1274.1347.734.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.2.0.box.172.1274.1347.364.q.60"
    }
  }, [_vm._v("In a heavy gumbo pot, heat the cooking oil over medium heat until hot, then add the flour, stirring constantly. Cook until the roux turns a dark, dark brown. Add the onions, bell pepper, celery, and garlic and saute until the vegetables are soft, about 10 minutes. Add the salt, black pepper, cayenne pepper, white pepper, Tabasco sauce, and ducks. Cook over medium heat for 15 minutes, stirring constantly. Add the sausage and continue to cook for 10 more minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.2.1.box.172.1649.1347.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.1.0"
    }
  }), _vm._v("Add the hot water and stir until the roux has dissolved. Bring to a boil, then reduce the heat to a low simmer and add the peeled boiled eggs, sweet basil, and bay leaf. Let the gumbo simmer over low heat for 2 hours, stirring a few times every hour. Add the green onion and parsley and cook for 10 more minutes. Skim off any excess fat. Serve hot in individual serving bowls with file powder over cooked white rice. Serves 8 to 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.3.0.box.172.2091.1348.198.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.31.3.0.box.172.2091.1348.198.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("May be made in advance and frozen or refri"), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.4.1.0"
    }
  }), _vm._v("gerated for later use. The flavor is not hurt at all by either process. To reheat, just thaw in the refrigerator if frozen, then heat over low heat.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.32.0.0.box.246.272.1254.318.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.0.0.box.246.272.1254.318.q.40"
    }
  }, [_vm._v("You can use this same recipe to make Blackbird Gumbo; just substitute 16 blackbirds for the 4 wild ducks. Do not cut the blackbirds in half; let them remain whole. About 761 calories per serving in 10 servings or 951 calories per serving in 8 servings. Add about 112 calories if you serve each bowl of gumbo with "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("V2 ")]), _vm._v("cup of cooked white rice.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.446.699.755.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.32.1.0.box.446.699.755.45.q.80"
    }
  }, [_vm._v("CROCK POT BEAN SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.32.2.0.box.152.817.1343.535.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0018.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.32.3.0.box.148.1418.1351.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.3.0.box.148.1418.1351.260.q.60"
    }
  }, [_vm._v("Put all ingredients into a crock pot set on low. Cook for at least 8 hours or until beans are tender. Mash some of the beans with a heavy spoon after the soup is cooked. Stir in the mashed beans to change the color and thickness of the soup. Serve as a main dish or as an appetizer. Serves about 6.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.4.0.box.147.1744.1351.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.32.4.0.box.147.1744.1351.313.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.5.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("Why make this in advance? It is just a pour-it-in, turn-iton-an"), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.5.1.0"
    }
  }), _vm._v("d-leave-it-all-day dish. It does refrigerate well after it is made and can be frozen, but the dish is so simple that I would suggest serving it at once. You can use any type of beans you like or even substitute dried peas. A hearty, filling soup. About 363 calories per serving.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.0.0.box.506.225.679.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.33.0.0.box.506.225.679.45.q.80"
    }
  }, [_vm._v("FRENCH ONION SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.33.1.0.box.171.341.1337.638.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0019.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.33.2.0.box.170.1034.1351.688.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.2.0.box.170.1034.1349.418.q.60"
    }
  }, [_vm._v("Peel onions and finely chop 2 of them. Cut the other 2 onions into thin slices; cut all the slices of 1 in half and separate the slices of the other into rings. In a heavy saucepan over medium heat, mix the butter and olive oil. Saute the onions for 3 minutes, then add the celery and green onion. Continue to saute until the onions begin to brown. Add the flour and cook until the flour is light brown. Add the sugar and Beef Stock and stir until the flour is absorbed. Add the Tabasco sauce, black pepper, white pepper, and salt to taste.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.2.1.box.171.1463.1350.259.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.3.1.0"
    }
  }), _vm._v("Let the soup simmer over very low heat for 20 minutes, then pour into individual soup bowls. Float a slice of French bread on top of each serving and cover each slice of bread with "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Vt ")]), _vm._v("cup of Gruyere cheese and 1 tablespoon of Parmesan cheese. Bake for about 15 minutes at 375 degrees. Serve hot right from the oven. Serves 4.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.3.0.box.171.1777.1351.531.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.33.3.0.box.171.1777.1350.306.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("You can make this soup in advance; just do"), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.4.1.0"
    }
  }), _vm._v("n't add the French bread or the cheeses. You can refrigerate the soup for up to 3 days before serving. The flavor will be excellent. To reheat, just follow the steps above, starting with pouring out the individual servings. Do not freeze this soup; it has a tendency to lose its taste and texture.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.33.3.1.box.274.2102.1248.206.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.4.2.0"
    }
  }), _vm._v("About 348 calories per serving. To reduce the calories considerably and still keep the great taste, cut the Gruyere cheese out completely and just cover the French bread with the Parmesan cheese. This will give you about 248 calories per serving.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.0.0.box.484.212.735.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.34.0.0.box.484.212.735.47.q.70"
    }
  }, [_vm._v("POTATO-ALMOND SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.1.0.box.173.330.1354.645.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0020.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.34.2.0.box.172.1029.1355.903.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.0.box.172.1029.1355.370.q.60"
    }
  }, [_vm._v("Wash the potatoes and place them in a large saucepan. Cover them with cold water and lightly salt the water. Boil until the potatoes are tender. In a large heavy saucepan over medium heat, melt the butter. Saute the onion and celery until the onions are clear, about 5 minutes. Add the Tabasco sauce, salt, Worcestershire sauce, white pepper, onion powder, and milk. Heat over medium heat, stirring constantly, until the milk begins to scald. Remove from heat.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.1.box.172.1409.1355.315.q.60"
    }
  }, [_vm._v("Peel the cooked potatoes and dice them into small pieces. Add them to the scalded milk mixture, then add the half-and-half. Cook until the mixture is smooth, about 10 minutes. Remove from heat and let cool slightly. Pour this mixture into a blender or food processor and add the toasted almonds. Blend until smooth. Add the Accent and heavy cream. Blend for 1 minute.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.2.box.173.1734.1354.198.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.3.2.0"
    }
  }), _vm._v("Pour the mixture into a large saucepan and add the Chicken Stock. Heat, stirring constantly, until the mixture is hot but not boiling. Serve hot, garnished with the minced green onion tops. Serves 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.3.0.box.172.1992.1356.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.34.3.0.box.172.1992.1356.314.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("When I was executive chef at Le Champignon"), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.4.1.0"
    }
  }), _vm._v(" Restaurant in Lakes Charles, Louisiana, this was my customers' favorite soup. It is a wonderful soup. You can make it in advance and store it in the refrigerator until you are ready to use it. Heat it over low heat or in the microwave. Be sure to stir it well before heating, for it does tend to separate when left standing"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.0.0.box.271.268.1250.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _vm._v("\nfor any period of time. Do not freeze. About 495 calories per serving.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.0.0.box.271.268.1250.99.q.70"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.321.449.1050.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.35.1.0.box.321.449.1050.47.q.80"
    }
  }, [_vm._v("CREAM OF FRESH SPINACH SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.35.2.0.box.169.550.1306.475.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0021.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.3.0.box.172.1083.1352.1009.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.0.box.172.1083.1351.300.q.60"
    }
  }, [_vm._v("Wash and chop the spinach. Place it in a heavy pot (about 2 quarts) and cover with cold water. Place the pot over medium heat and bring the water to a boil. When the water starts to boil, reduce the heat to low and let the spinach simmer, covered, for 15 minutes. Add the Chicken Stock and simmer for 5 minutes, then remove from heat and allow to cool.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.1.box.172.1403.1352.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.1.0"
    }
  }), _vm._v("In a small skillet over medium heat, melt the butter and saute the onion and celery for 5 minutes. Add the flour and cook for 2 minutes. Add this light roux to the soup base and stir in well. Put the mixture into a blender and blend for 2 minutes at high speed or until all the spinach is chopped fine. (You may use a food processor, but be sure that the liquid will not leak out of the bottom.)")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.2.box.172.1725.1352.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.4.2.0"
    }
  }), _vm._v("When the soup is well blended, return it to the large pot and bring it to a boil. It should thicken somewhat. Beat the egg yolks and heavy cream together well. Add some of the hot soup base to the egg-cream mixture until the mixture becomes quite hot. Reduce the soup base heat to a low simmer and add the egg-cream mixture. Add the salt, Tabasco sauce, black pepper, and white pepper and stir well. Let the soup get hot again, but do "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _vm._v("let it boil. Serve hot. Serves 6.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.4.0.box.171.2145.1353.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.35.4.0.box.171.2145.1353.205.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("A great cream soup—not really heavy, but"), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.5.1.0"
    }
  }), _vm._v(" thick enough to be quite nice. You can do a lot with this recipe; for instance, you can substitute any number of vegetables to make the kind of cream soup you want. Use asparagus and it becomes Cream"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.0.0.box.272.205.1251.479.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _vm._v("\nof Fresh Asparagus Soup. Use yellow squash and it becomes Cream of Fresh Yellow Squash Soup. Use carrots and it becomes Cream of Fresh Carrot Soup. Use zucchini and it becomes Cream of Fresh Zucchini Soup. Use fresh leeks and it becomes Cream of Fresh Leek Soup. Use broccoli and it becomes Cream of Fresh Broccoli Soup. I could go on and on, but these are the ones that I have personally kitchen-tested. All you do is substitute 1 pound of fresh vegetable for the spinach.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.36.0.0.box.272.205.1251.915.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.0.1.box.272.696.1251.424.q.50"
    }
  }, [_vm._v("This soup can be made in advance and stored in the refrigerator. Do not freeze it, though. It will keep for 4 or 5 days in the refrigerator; just stir it through (it might separate slightly during storage) and heat it up, but do not let it boil! The spinach version has about 226 calories per serving; the asparagus, 222 calories; the squash. 226; the carrot, 230; the zucchini, 224; the leek, 232; and the broccoli, about 226 calories. All are low in calories, but high in flavor!")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.375.1216.947.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.36.1.0.box.375.1216.947.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.2.0"
    }
  }), _vm._v("HOMEMADE VEGETABLE SOUP")]), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.4.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.6.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.36.2.0.box.172.1335.1349.961.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.3.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0022.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.0.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.2.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.3.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.4.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.5.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.4.6.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.5.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.37.0.0.box.174.263.1348.635.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.0.0.box.175.263.1347.306.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _vm._v("In the oven, broil the soup bone for 12 minutes on each side. When you start the second side, add the soup meat and broil it for 4 minutes on each side. Place the soup bone and soup meat in a large soup pot or stockpot and cover with the gallon of water. Bring the water to a boil, then reduce to a low simmer and cook the bone and meat for 1 hour.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.0.1.box.174.589.1347.309.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.1.0"
    }
  }), _vm._v("Add the stewed tomatoes, celery, carrots, onion, and turnips. Cover and cook for 1 hour. Add the cabbage, green beans, corn, potatoes, parsley, green onion tops, and garlic. Cover and cook for 30 minutes. Add the remaining ingredients, cover, and cook for 30 minutes. Remove the soup bone and cook for 20 more minutes. Serve hot. Serves 10 to 12.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.173.971.1349.528.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.37.1.0.box.173.971.1349.197.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("To scrape the corn off the cob, stand the "), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  }), _vm._v("ear of corn on end and scrape the kernels off from the middle to the bottom of the ear with a downward motion all around, then repeat for the other end of the ear.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.275.1187.1246.312.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.2.0"
    }
  }), _vm._v("This can be made in advance and either frozen or refrigerated for later use. To reheat, just thaw in the refrigerator if frozen, then heat on top of the stove until it reaches serving temperature. It is really great to make this soup when vegetables are fresh and plentiful. About 430 calories per serving in 10 servings and 359 calories per serving in 12 servings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.0.0.box.483.272.657.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.38.0.0.box.483.272.657.46.q.70"
    }
  }, [_vm._v("CAJUN TURTLE SOUP")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.38.1.0.box.134.390.1353.1179.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0023.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.2.0.box.134.1633.1352.691.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.0.box.134.1633.1352.368.q.60"
    }
  }, [_vm._v("Remove as much meat from the turtle bones as possible and season the meat with the Seafood Seasoning Mix. In a heavy saucepan, heat the oil over medium heat and fry the turtle meat until it is nicely browned on all sides. While the meat is browning, put the turtle bones into a large stockpot with the 3 quarts of water, the 2 carrots, the 1⁄4 bunch of parsley, the bay leaf, and the stalk of celery. Bring the water to a boil, then reduce the heat to a rolling simmer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.1.box.134.2011.1352.313.q.60"
    }
  }, [_vm._v("When the turtle meat is browned, add the flour and make a medium-brown roux, stirring constantly over medium heat. Add the onions, the chopped celery, the minced carrots, bell pepper, and garlic and saute in the roux mixture for 5 minutes. Add the tomato puree and blend it into the roux well. Add the Beef Stock and cook this mixture for 30 minutes over very low heat, stirring often.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.0.0.box.243.249.1347.481.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.0.0.box.243.249.1347.255.q.60"
    }
  }, [_vm._v("Add the lemon juice, Worcestershire sauce, Tabasco sauce, 3 bay leaves, sweet basil, thyme, black pepper, white pepper, garlic powder, onion powder, and the liquid that the turtle bones have been simmering in. (Be sure to strain the liquid before adding it to the pot.) Reduce the heat to simmer and cook for 15 minutes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.0.1.box.243.523.1346.207.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.1.0"
    }
  }), _vm._v("Chop the turtle meat into small pieces and add it to the simmering mixture. Cook at a low simmer for 30 minutes, then add the sherry, salt, and "), _c('i', [_vm._v("½ ")]), _vm._v("cup of parsley and simmer for 5 minutes. Serve hot in individual serving bowls with chopped egg if desired. Serves 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.1.0.box.242.794.1348.316.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.39.1.0.box.242.794.1348.316.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This dish may be made in advance and eithe"), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  }), _vm._v("r refrigerated or frozen. To reheat, just thaw in the refrigerator if frozen and heat over low heat until hot, adding eggs if desired. This is an excellent appetizer for any meal. About 260 calories per serving without the chopped egg or 280 calories with the chopped egg.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.2.0.box.623.1241.587.54.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.39.2.0.box.623.1241.587.54.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.3.0.0"
    }
  }), _vm._v("CRAWFISH BISQUE")]), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.1.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.3.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.39.3.0.box.239.1356.1346.924.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.4.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.5.0.1"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.4.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.5.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.1.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.3.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.4.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.40.0.0.box.174.277.1350.993.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.6.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.7.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.2.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.3.0.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.40.1.0.box.173.1326.1353.708.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h2_heading",
    attrs: {
      "id": "para.40.1.0.box.173.1326.820.35.q.70"
    }
  }, [_vm._v("To make the stuffed crawfish heads:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.173.1405.1353.253.q.60"
    }
  }, [_vm._v("Soak live crawfish in fresh water for 15 minutes, then clean each one well. Put them in a large stockpot and cover with plenty of fresh cold water (at least 1 gallon). Place pot over medium heat and bring the water to a boil, then reduce heat to simmer and let the crawfish cook for 1 to 3 hours at a low simmer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.173.1677.1352.357.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.3.1.0"
    }
  }), _vm._v("Remove the crawfish from the water after cooking, reserving the water for later use. Let the crawfish cool until you can handle them easily. Clean one crawfish at a time as follows: break off and discard the tail; separate the head from the body (just behind the eyes); and use your thumb to clean out the body. This body shell is what you will stuff. Repeat this process until all the crawfish are cleaned. Wash the shells and set them aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.2.0.box.173.2091.1353.231.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h2_heading",
    attrs: {
      "id": "para.40.2.0.box.173.2091.484.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.4.0.0"
    }
  }), _vm._v("To make the stuffing:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.2.1.box.174.2171.1352.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.5.0.0"
    }
  }), _vm._v("Grind together the crawfish tails and fat, the chopped large onions, the chopped medium bell pepper, the minced celery, and the tablespoon of minced garlic until well ground. (You can use a food"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.0.0.box.178.263.1347.251.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _vm._v("\nprocessor and chop everything very fine if a grinder is not available.) In a heavy metal pot over medium heat, saute this mixture in the butter for 12 minutes, stirring often. While sauteing the vegetables, soak the French bread in enough milk to soften it, then squeeze the milk out of the bread and set the bread aside.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.41.0.0.box.178.263.1347.632.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.0.1.box.178.533.1346.362.q.60"
    }
  }, [_vm._v("When the sauteing time is up, add the soaked bread, Seafood Seasoning Mix, Tabasco sauce, Worcestershire sauce, black pepper, parsley, green onion, evaporated milk, and egg and remove from the heat. Stir stuffing until completely blended. Stuff 1 to 1½ tablespoons of stuffing into each crawfish body shell. Roll the shells in flour. Place on a baking sheet and bake at 350 degrees for 20 minutes. Remove from oven and let cool.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.41.1.0.box.175.972.1349.824.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h2_heading",
    attrs: {
      "id": "para.41.1.0.box.175.972.462.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("To make the bisque:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.175.1050.1348.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0"
    }
  }), _vm._v("As the shells go into the oven, begin to make the bisque. In a heavy saucepot over medium heat, heat the peanut oil until hot. Add the % cup of flour to make the roux, stirring constantly until the roux is golden brown. Add the chopped medium onions, the small chopped bell pepper, the chopped celery, and the 2 minced garlic cloves and saute for 5 minutes. Add the tomatoes without their liquid (reserve the liquid) and saute for 7 minutes, stirring constantly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.176.1427.1348.369.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.1.0"
    }
  }), _vm._v("Add the tomato liquid, tomato paste, crawfish tails, and crawfish water. Bring to a slow boil, then reduce to a low simmer and add the Seafood Seasoning Mix, salt, Tabasco sauce, bay leaves, sweet basil, and thyme. Simmer for 1 hour over very low heat. Then add the stuffed crawfish shells, the ½ cup of green onion, and the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Vn ")]), _vm._v("cup of parsley and simmer for 10 more minutes. Serve hot over cooked white rice. Serves 8. This is real Cajun eating!")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.2.0.box.172.1874.1348.421.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.41.2.0.box.172.1874.1348.421.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This dish may be (and almost has to be) ma"), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.1.0"
    }
  }), _vm._v("de in advance and either refrigerated or frozen. If you are going to freeze it, keep the heads separate and freeze them just before baking. The bisque itself can be completely made and frozen. To serve, take the stuffed heads from the freezer and bake them, frozen, for 25 minutes at 350 degrees. Heat the bisque to a low simmer and add the heads, green onion, and parsley to the bisque, then serve hot over the rice.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.42.0.0.box.273.272.1251.252.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.0.0.box.273.272.1251.252.q.60"
    }
  }, [_vm._v("You can also make this recipe in its various parts and assemble it when ready to serve. This is a real company dish that shows you really care. About 573 calories per serving of this outstanding dish. No reduction or change in this recipe is recommended.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.667.641.363.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.42.1.0.box.667.641.363.45.q.80"
    }
  }, [_vm._v("COLE SLAW")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.42.2.0.box.172.761.1347.477.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0026.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.42.3.0.box.171.1312.1352.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.3.0.box.171.1312.1352.362.q.60"
    }
  }, [_vm._v("Mix both cabbages, the green onion, parsley, and garlic. Cover tightly and refrigerate for 1 hour. In a separate bowl, mix the mayonnaise, sour cream, Tabasco sauce, lemon juice, and black pepper. Cover dressing tightly and refrigerate for 1 hour. Pour the dressing over the vegetables and toss until the vegetables are well coated. Add salt and toss well. Cover tightly and refrigerate for at least 1 hour. Serve chilled. Serves 8 to 10.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.4.0.box.171.1748.1352.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.42.4.0.box.171.1748.1352.205.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.5.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This salad can be made a day or even 2 day"), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.5.1.0"
    }
  }), _vm._v("s in advance and stored in the refrigerator. Do not freeze. It is excellent with all fried seafood or with a sandwich. About 205 calories per serving in 10 servings or 255 calories per serving in 8 servings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.0.0.box.566.268.558.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.43.0.0.box.566.268.558.46.q.80"
    }
  }, [_vm._v("CRAWFISH SALAD")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.43.1.0.box.170.388.1346.534.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0027.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.43.2.0.box.170.988.1350.197.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.2.0.box.170.988.1350.197.q.50"
    }
  }, [_vm._v("Combine all of the ingredients except the salt and mix until well blended. Taste and season with salt if needed (the crawfish should be well seasoned from the crawfish boil). Serve warm or chilled. Serves 4.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.3.0.box.170.1259.1352.469.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.43.3.0.box.170.1259.1351.147.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This salad is an excellent way to use craw"), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.4.1.0"
    }
  }), _vm._v("fish left over from a crawfish boil. It can be made up to 2 days in advance but is best when served the day it is made.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.43.3.1.box.271.1417.1251.311.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.4.2.0"
    }
  }), _vm._v("You can use this recipe to make Shrimp Salad by substituting 2½ cups of peeled, deveined, and diced boiled shrimp for the crawfish. To make Lump Crabmeat Salad, use 1 pound of fresh lump crabmeat in place of the crawfish. The crawfish version has about 371 calories per serving; the shrimp version about 398; and the lump crabmeat version about 374.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.0.0.box.611.272.475.44.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.44.0.0.box.611.272.475.44.q.80"
    }
  }, [_vm._v("POTATO SALAD")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.44.1.0.box.173.389.1350.586.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0028.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.3.0.0.2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.3.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.44.2.0.box.173.1041.1352.685.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.2.0.box.174.1041.1350.315.q.60"
    }
  }, [_vm._v("Wash the potatoes and put them in a large pot. Add the eggs in their shells and fill the pot with cold water to just above the potatoes and eggs. Add the salt and place over high heat. Boil at a rolling boil until the potatoes are tender when pierced with a table fork. Remove the potatoes and eggs from the boiling water and let them cool until they are cool enough to handle.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.2.1.box.173.1366.1352.360.q.60"
    }
  }, [_vm._v("Use a knife and remove the skin from the potatoes, then chop them into large dice and put them into a large bowl. Peel the eggs, chop them well, and add them to the potatoes. Add the onions, pickle relish, celery, pimento, mustard, black pepper, salt, white pepper, parsley, and green onion tops. Toss lightly until well mixed. Add the mayonnaise and mix well. Serve immediately, or refrigerate and serve chilled. Serves 8.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.3.0.box.173.1800.1353.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.44.3.0.box.173.1800.1353.311.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("Do not freeze. You can make this up to 2 d"), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.4.1.0"
    }
  }), _vm._v("ays ahead and refrigerate it, but be careful not to leave it out of the refrigerator for too long or it w"), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.4.2.0"
    }
  }), _vm._v("ill spoil. I like potato salad best just after it is made, when it is still slightly warm. This is excellent with many dishes and a real treat with gumbo. About 341 calories per serving.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.0.0.box.313.267.1059.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.45.0.0.box.313.267.1059.46.q.80"
    }
  }, [_vm._v("CAJUN FRENCH SALAD DRESSING")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.45.1.0.box.170.385.1326.524.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0029.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.45.2.0.box.172.967.1351.526.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.0.box.172.967.1348.261.q.60"
    }
  }, [_vm._v("Place the vinegar, Tabasco sauce, sugars, chili sauce, catsup, onion, and garlic in a food processor. Blend at high speed until the sugars are dissolved. Add the salt, sweet basil, paprika, onion powder, garlic powder, lemon juice, mustard, file powder, and egg white. Blend at high speed for 1 minute.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.1.box.172.1238.1351.255.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.3.1.0"
    }
  }), _vm._v("With the processor running on low power, slowly drizzle the oil through the opening at the top into the processor until all the oil has been poured in. Refrigerate until ready to use. Serve on any green salad; it is also excellent on avocados. Makes about 3 cups of dressing.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.45.3.0.box.171.1548.1352.262.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.45.3.0.box.171.1548.1352.262.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.4.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("This is a great make-ahead salad dressing "), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.4.1.0"
    }
  }), _vm._v("that will keep in your refrigerator for about 1 week. If you do not have a food processor, a blender will do. Or, you can mix by hand with a wire whisk, but be prepared to have a sore arm. About 85 calories per tablespoon or 28 calories per teaspoon of dressing.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.4.0.box.366.1893.967.52.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.45.4.0.box.366.1893.967.52.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.6.2.0"
    }
  }), _vm._v("QUICK POPPY SEED DRESSING")]), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.8.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.45.5.0.box.175.1992.1319.308.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0030.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.46.0.0.box.170.271.1353.644.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.0.0.box.170.271.1352.263.q.60"
    }
  }, [_vm._v("This is a food processor dressing. Place the onion in the processor, turn it on full power, and let it run until the onion liquifies. Add the sugar, white pepper, mustard, Tabasco sauce, lemon juice, and vinegar. Turn the processor on full power and blend for 1 minute. The sugar should dissolve in the vinegar.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.0.1.box.171.544.1352.371.q.60"
    }
  }, [_vm._v("With the processor running on low speed, drizzle the salad oil into the center of the processor until all of the oil is blended in. Mix in the poppy seeds in the same manner, mixing for 30 seconds more after the poppy seeds are blended in. Pour into a quart jar and store in the refrigerator to use as needed. If the mixture starts to separate, just shake the jar rapidly a few times to remix the ingredients. Makes about 1 quart of dressing. Excellent over fruit or any salad greens.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.46.1.0.box.170.978.1354.587.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.46.1.0.box.170.978.1354.205.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("Talk about a wonderful dressing! It keeps "), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  }), _vm._v("for a couple of weeks in the refrigerator and is so much better in quality than the poppy seed dressings you buy at the store. It is so easy to make that you can always keep plenty on hand.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em",
      "margin-left": "1em"
    },
    attrs: {
      "id": "para.46.1.1.box.271.1193.1253.372.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  }), _vm._v("If you do not have a food processor, you can use a blender, but it may take a little more time, and it may be harder to chop up the onion. You can add the vinegar to the onion to make it easier to chop. If you are really eager, you can make this dressing by hand using a good wire whisk; just beat it until you turn blue. About 85 calories per tablespoon or 28 calories per teaspoon of dressing.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.2.0.box.401.1691.890.44.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.46.2.0.box.401.1691.890.44.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.3.2.0"
    }
  }), _vm._v("RED WINE SALAD DRESSING")]), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.4.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.5.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.46.3.0.box.171.1807.1348.471.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0031.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.47.0.0.box.171.277.1349.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.0.0.box.171.277.1349.311.q.60"
    }
  }, [_vm._v("Place the wine, vinegar, sugar, lemon juice, garlic, parsley, bell pepper, Worcestershire sauce, and Tabasco sauce into a large bowl and beat well with a wire whisk until the sugar is dissolved. Add the bay leaf, mustard, and salt, then slowly beat in the olive oil. Let the dressing stand at room temperature for 4 hours, then refrigerate. Makes a little over 2 cups of dressing.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.170.654.1352.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.47.1.0.box.170.654.1352.314.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("Lagniappe: ")]), _vm._v("It is very easy to make this dressing in a"), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.1.0"
    }
  }), _vm._v(" food processor or blender. Just put in all the ingredients except the olive oil and mix on high speed for 1 minute. Slowly drizzle in the olive oil until well mixed. Let stand as above. Excellent on top of any green salad. It keeps in the refrigerator for about a week. About 48 calories per tablespoon of dressing or about 16 per teaspoon.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e8e587b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0032.vue
// module id = 66
// module chunks = 0